<div class="sidebar">
  <div class="menu-top">
    <div class="menu-item menu-item-first" (click)="toggleSidebar()">
      <img
        *ngIf="!collapsed"
        type="image/png"
        src="assets/icon/favicon.png"
        width="25"
      />
      <b *ngIf="!collapsed">Baulogistik</b>
      <ion-icon
        [name]="collapsed ? 'chevron-forward-outline' : 'chevron-back-outline'"
      ></ion-icon>
    </div>
    <div
      class="menu-item"
      *ngFor="let item of topMenu"
      [routerLink]="item.routerLink"
      routerLinkActive="active"
      [attr.title]="collapsed ? item.title : null"
    >
      <ion-icon [name]="item.icon"></ion-icon>
      <span style="margin-left: 12px" *ngIf="!collapsed">{{ item.title }}</span>
    </div>
  </div>

  <div class="menu-bottom">
    <div
      class="menu-item"
      *ngFor="let item of bottomMenu"
      [routerLink]="item.routerLink"
      routerLinkActive="active"
      [attr.title]="collapsed ? item.title : null"
    >
      <ion-icon [name]="item.icon"></ion-icon>
      <span style="margin-left: 12px" *ngIf="!collapsed">{{ item.title }}</span>
    </div>
    <div (click)="logout()" title="Logout" class="menu-item">
      <ion-icon name="log-out-outline"></ion-icon>
      <span style="margin-left: 12px" *ngIf="!collapsed">Logout</span>
    </div>
  </div>
</div>
